// 等待页面加载完成
document.addEventListener('DOMContentLoaded', function() {
  // 获取核心元素
  const searchInput = document.getElementById('header-search-input');
  const resultsDropdown = document.getElementById('search-results-dropdown');
  let debounceTimer = null; // 防抖计时器

  // 1. 防抖函数：避免输入时频繁请求API
  function debounce(func, delay) {
    return function(...args) {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => func.apply(this, args), delay);
    };
  }

  // 2. 获取并渲染搜索建议（核心：适配data.resources.results.products层级）
  async function fetchSearchSuggestions(terms) {
    // 输入为空/少于2个字符时清空并隐藏下拉框
    if (!terms.trim() || terms.length < 2) {
      resultsDropdown.innerHTML = '';
      resultsDropdown.style.display = 'none';
      return;
    }

    try {
      // 拼接API参数，兼容特殊字符
      const searchParams = new URLSearchParams({
        q: terms,
        'resources[type]': 'product',
        'resources[limit]': 10 // 可按需调整显示数量
      });
      // 调用Shopify搜索建议API
      const response = await fetch(`/search/suggest.json?${searchParams.toString()}`);
      
      if (!response.ok) {
        throw new Error(`请求失败：${response.status}`);
      }

      const data = await response.json();
      console.log('完整返回数据：', data); // 调试日志

      // 🌟 核心修正：适配你的实际数据层级 data.resources.results.products
      let products = [];
      // 你的实际路径（优先级最高）
      if (data.resources?.results?.products) {
        products = data.resources.results.products;
      }
      // 兼容新版Shopify默认路径
      else if (data.resources?.products) {
        products = data.resources.products;
      }
      // 兼容旧版Shopify路径
      else if (data.products) {
        products = data.products;
      }

      console.log('解析到的产品列表：', products); // 查看解析后的产品数据
      // 清空原有下拉内容
      resultsDropdown.innerHTML = '';

      // 无产品时显示提示
      if (products.length === 0) {
        resultsDropdown.innerHTML = '<div class="search-result-empty">No Result</div>';
        resultsDropdown.style.display = 'block';
        return;
      }

    
// 渲染产品下拉选项（适配新CSS的图片+标题+价格布局）
products.forEach(product => {
  // 基础兜底（防止个别产品数据异常）
  const prodTitle = product.title || '未知产品';
  const prodUrl = product.url || '#';
  const prodPrice = product.price || '0.00';
  // 优先用featured_image，没有则用普通image
  const prodImg = product.featured_image?.url || product.image || '';

  const item = document.createElement('a');
  item.href = prodUrl;
  item.className = 'search-result-item';
  
  // 生成图片+标题+价格的HTML结构
  item.innerHTML = `
    <img 
      src="${prodImg}" 
      alt="${prodTitle}" 
      class="product-image"
      onerror="this.style.display='none'" // 图片加载失败时隐藏
    >
    <div class="product-info">
      <div class="product-title">${prodTitle}</div>
      <div class="product-price">$${prodPrice}</div>
    </div>
  `;

  // 点击产品后隐藏下拉框
  item.addEventListener('click', () => {
    resultsDropdown.style.display = 'none';
  });
  resultsDropdown.appendChild(item);
});

      // 显示下拉框
      resultsDropdown.style.display = 'block';
    } catch (error) {
      console.error('获取搜索建议失败：', error);
      resultsDropdown.innerHTML = '<div class="search-result-empty">加载失败，请重试</div>';
      resultsDropdown.style.display = 'block';
    }
  }

  // 3. 监听输入框输入事件（防抖300ms）
  searchInput.addEventListener('input', debounce(function(e) {
    fetchSearchSuggestions(e.target.value);
  }, 300));

  // 4. 点击页面其他区域隐藏下拉框
  document.addEventListener('click', function(e) {
    if (!searchInput.contains(e.target) && !resultsDropdown.contains(e.target)) {
      resultsDropdown.style.display = 'none';
    }
  });

  // 5. 按ESC键隐藏下拉框
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      resultsDropdown.style.display = 'none';
    }
  });
});